// extracted by mini-css-extract-plugin
export default {"background":"styles_background__ol59i","container":"styles_container__444BG","title":"styles_title__ZHC7Z","loginBox":"styles_loginBox__lFEfE"};